import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Projects from './components/Projects';
import About from './components/About';
import Brands from './components/Brands';
import Contact from './components/Contact';
import Footer from '@/components/feature/Footer';

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const tryScroll = (attemptsLeft: number) => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        } else if (attemptsLeft > 0) {
          setTimeout(() => tryScroll(attemptsLeft - 1), 100);
        }
      };
      setTimeout(() => tryScroll(10), 50);
    }
  }, [location.hash]);

  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <Hero />
      <Services />
      <Projects />
      <About />
      <Brands />
      <Contact />
      <Footer />
    </div>
  );
}